import { render, staticRenderFns } from "./TrekRecaptcha.vue?vue&type=template&id=3a3b3aba&"
import script from "./TrekRecaptcha.vue?vue&type=script&lang=js&"
export * from "./TrekRecaptcha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports